/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDocument } from '../../models/user-document';

export interface UserDocumentsControllerGetDocuments$Params {
  userId: string;
}

export function userDocumentsControllerGetDocuments(http: HttpClient, rootUrl: string, params: UserDocumentsControllerGetDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UserDocument>>> {
  const rb = new RequestBuilder(rootUrl, userDocumentsControllerGetDocuments.PATH, 'get');
  if (params) {
    rb.path('userId', params.userId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UserDocument>>;
    })
  );
}

userDocumentsControllerGetDocuments.PATH = '/user-documents/{userId}';
